exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recNews{\n\tfont-family: 'Marvel','sans-serif';\n\ttext-align:center;\n\tfont-size:22px;\n\tcolor:#222;\n\tmargin-top: -10px;\n\tcursor: pointer;\n    margin-bottom:3%;\n}\n.recNewsCont{\n\ttext-align: left;\n\tfont-size: 16px !important;\n\tpadding-bottom: 22px;\n}\n.recNewsCont:hover>a{\n\t text-decoration: underline;\n\t color: red !important; \n\t cursor: pointer;\n}\n.homeTable{\n\tmargin-top:20px;\n\theight:300px;\n\tbackground-color: #f2f2f2;\n\twidth: 250px !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/home/home.component.css
// module id = ../../../../../src/app/home/home.component.css
// module chunks = main